import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CollapsableRow from '../../../../collapsableRow/CollapsableRow';
import Icon, { IconSizes } from '../../../../components/foundations/Icon';
import ToggleTabGroup from '../../../../components/atoms/ToggleTabGroup';
import SuggestionItem from './SuggestionItem';
import css from './SuggestionsSection.css';
import withTranslate from '../../../../containers/widgets/withTranslate';
import { INSIGHTS_KEY_PREFIX, DEFAULT_SUGGESTION_MODE, SUGGESTION_TOGGLE_OPTIONS } from '../consts';

const SuggestionsSection = ({ suggestions, expandedCategory, onCategoryClick, translate }) => {
    const [selectedMode, setSelectedMode] = useState(DEFAULT_SUGGESTION_MODE);

    if (!suggestions) return null;

    const CREATIVE_FEEDBACK = 'creative_feedback';

    const toggleOptions = SUGGESTION_TOGGLE_OPTIONS.map(option => ({
        option: option.option,
        label: translate(option.labelKey),
    }));

    const displayedSuggestions = suggestions[selectedMode];

    return (
        <CollapsableRow
            onClick={() => onCategoryClick(CREATIVE_FEEDBACK)}
            expanded={expandedCategory === CREATIVE_FEEDBACK}
            title={
                <div className={css.titleContainer}>
                    <Icon name="sparkles" size={IconSizes.MEDIUM} className={css.icon4} interactive={false} />
                    <span className={css.title}>{translate(`${INSIGHTS_KEY_PREFIX}.SUGGESTIONS`)}</span>
                </div>
            }
        >
            <div className={css.insightContainer}>
                <div className={css.toggleContainer}>
                    <ToggleTabGroup options={toggleOptions} selectedOption={selectedMode} onToggle={setSelectedMode} />
                </div>
                <div>
                    {displayedSuggestions?.map((suggestion, index) => (
                        <SuggestionItem key={`suggestion-${index}`} creativeData={suggestion} index={index} />
                    ))}
                </div>
            </div>
        </CollapsableRow>
    );
};

SuggestionsSection.propTypes = {
    suggestions: PropTypes.shape({
        top_creatives: PropTypes.array,
        bottom_creatives: PropTypes.array,
    }),
    expandedCategory: PropTypes.string,
    onCategoryClick: PropTypes.func,
    translate: PropTypes.func,
};

export default withTranslate(SuggestionsSection);
